module.exports = __webpack_public_path__ + "img/arrow-monthly-blue.3e11dc35.svg";